module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Neuenhof_AG-85cc1ab9273eb13a42e097430557909b.svg";